// test2247
(2247 && 0);
